import moment from "moment";
import * as React from "react";
import { config } from "../../../../config/domain";
import { useHistory } from "react-router-dom";
import Loader from "../../../generic/loader";
import * as esignService from "../../../service/esign/esignService";
import { asyncGetServiceRequest } from "../../../service/postLogin/clientProfileAPIService";
// import "../../../assets/scss/components/login/loginScreen/loginHelp.scss";
import tooltipIcon from "../../../../assets/images/notes-green-small.svg";
export interface ILoginHelpProps {}
const types = (name: any) => {
  switch (name) {
    case "Bank Modification":
      return "bank";
    case "Email and Phone Update":
      return "emailMob";
    case "Change of Address":
      return "address";
    case "Equity Dormant Reactivation":
      return "accReact";
    default:
      return;
  }
};
const Status = (data: any) => {
  if (data.RequestType === "Email and Phone Update") {
    switch (data.RequestStatus) {
      case "None":
      case "":
      case "PendingForEsign":
        return { badge: "orange_bdg", value: "Esign Pending" };
      case "Approved":
        return { badge: "orange_bdg", value: "Submit" };
      case "Processed":
        return { badge: "green_bdg", value: "Closed" };
      case "Rejected-EsignNotSubmitted":
      case "Rejected":
        return { badge: "red_bdg", value: "Rejected" };
      case "EsignSubmitted":
        return { badge: "orange_bdg", value: "Submit" };
      case "AssignedForEsignQC":
      case "PendingForProcessing":
      case "PushToTarget":
      case "EsignVerified":
        return { badge: "orange_bdg", value: "In Process" };
      case "Submitted":
        return { badge: "orange_bdg", value: "Pending" };
      default:
    }
  } else if (data.RequestType === "Bank Modification") {
    switch (data.RequestStatus) {
      case "None":
      case "":
      case "PendingForEsign":
        return { badge: "orange_bdg", value: "Pending" };
      case "Processed":
        return { badge: "green_bdg", value: "Completed" };
      case "Rejected-EsignNotSubmitted":
      case "Rejected-Autoexpired":
      case "Rejected - Resubmit":
      case "Rejected":
        return { badge: "red_bdg", value: "Rejected" };
      case "EsignSubmitted":
      case "AssignedForEsignQC":
      case "PendingForProcessing":
      case "PushToTarget":
      case "AssignedToHO":
      case "EsignVerified":
      case "Resubmitted":
      case "Submitted":
      case "Approved":
        return { badge: "orange_bdg", value: "In Process" };
      default:
    }
  } else if (data.RequestType === "Change of Address") {
    switch (data.RequestStatus) {
      case "None":
      case "":
      case "PendingForEsign":
        return { badge: "orange_bdg", value: "Pending" };
      case "Processed":
        return { badge: "green_bdg", value: "Completed" };
      case "Rejected-EsignNotSubmitted":
      case "Rejected-Autoexpired":
      case "Rejected - Resubmit":
      case "Rejected":
        return { badge: "red_bdg", value: "Rejected" };
      case "EsignSubmitted":
      case "AssignedForEsignQC":
      case "PendingForProcessing":
      case "PushToTarget":
      case "AssignedToHO":
      case "EsignVerified":
      case "Resubmitted":
      case "Submitted":
      case "Approved":
        return { badge: "orange_bdg", value: "In Process" };
      default:
    }
  } else if (data.RequestType === "CKYC Update") {
    switch (data.RequestStatus) {
      case "None":
      case "":
      case "Approved":
        return { badge: "orange_bdg", value: "Submit" };
      case "Processed":
        return { badge: "green_bdg", value: "Completed" };
      case "Rejected-Autoexpired":
      case "Rejected - Resubmit":
      case "Rejected":
        return { badge: "red_bdg", value: "Rejected" };
      case "Approved":
      case "Resubmitted":
      case "AssignedToHO":
      case "InProcess":
      case "Submitted":
        return { badge: "orange_bdg", value: "In Process" };
      default:
    }
  } else if (data.RequestType === "FATCA Declaration") {
    switch (data.RequestStatus) {
      case "None":
      case "":
        return { badge: "orange_bdg", value: "Submit" };
      case "Processed":
        return { badge: "green_bdg", value: "Completed" };
      case "Approved":
      case "PushToTarget":
      case "PendingForProcessing":
        return { badge: "orange_bdg", value: "In Process" };
      case "Rejected":
        return { badge: "red_bdg", value: "Rejected" };
      default:
    }
  } else if (data.RequestType === "CKYC Update") {
    switch (data.RequestStatus) {
      case "None":
      case "":
      case "Approved":
        return { badge: "orange_bdg", value: "Submit" };
      case "Processed":
        return { badge: "green_bdg", value: "Completed" };
      case "Rejected-Autoexpired":
      case "Rejected - Resubmit":
      case "Rejected":
        return { badge: "red_bdg", value: "Rejected" };
      case "Approved":
      case "Resubmitted":
      case "AssignedToHO":
      case "InProcess":
      case "Submitted":
      case "PendingForProcessing":
        return { badge: "orange_bdg", value: "In Process" };
      default:
    }
  } else {
    switch (data.RequestStatus) {
      case "None":
      case "":
      case "PendingForEsign":
        return { badge: "orange_bdg", value: "Esign Pending" };
      case "Approved":
        return { badge: "orange_bdg", value: "Submit" };
      case "Processed":
        return { badge: "green_bdg", value: "Closed" };
      case "Rejected-EsignNotSubmitted":
      case "Rejected":
        return { badge: "red_bdg", value: "Rejected" };
      case "EsignSubmitted":
        return { badge: "orange_bdg", value: "Submit" };
      case "AssignedForEsignQC":
      case "PendingForProcessing":
      case "PushToTarget":
      case "EsignVerified":
        return { badge: "orange_bdg", value: "In Process" };

      case "MemorandumPaymentPending":
        return { badge: "orange_bdg", value: "Pending" };
      case "Submitted":
        return { badge: "orange_bdg", value: "Pending" };
      default:
    }
  }
};

const Table: React.FC<any> = (props) => {
  const [pageData, setPageData] = React.useState([]);
  const [loader, setLoader] = React.useState(false);
  const [show, setShow] = React.useState(false);
  const [reactList, setReactList] = React.useState<any>();
  const history = useHistory();

  React.useEffect(() => {
    setPageData(props.sourceData);
    if (props.sourceData && props.sourceData.length > 0) {
      props.sourceData.map(async (data: any) => {
        if (
          data.RequestType === "Equity Dormant Reactivation" &&
          (data.RequestStatus === "Draft Saved" ||
            data.RequestStatus === "Approved" ||
            data.RequestStatus === "Submitted" ||
            data.RequestStatus === "MemorandumPaymentPending")
        ) {
          const reactList1 = await asyncGetServiceRequest(data.RequestId);
          setReactList(reactList1);
          // reactList = [
          //   {
          //     createdDate: "2021-08-11T13:15:00.866044",
          //     RequestId: "7275",
          //     RequestType: "FATCA Declaration",
          //     RequestStatus: "Approved",
          //     ExcepetedDateOfCompletion: null,
          //   },
          //   {
          //     createdDate: "2021-08-11T13:15:06.118548",
          //     RequestId: "7276",
          //     RequestType: "Income Declaration",
          //     RequestStatus: "Approved",
          //     ExcepetedDateOfCompletion: null,
          //   },
          //   {
          //     createdDate: "2021-08-11T13:15:12.003338",
          //     RequestId: "7277",
          //     RequestType: "Email and Phone Update",
          //     RequestStatus: "Approved",
          //     ExcepetedDateOfCompletion: null,
          //   },
          //   {
          //     createdDate: "2021-08-11T13:16:49.67083",
          //     RequestId: "7278",
          //     RequestType: "Change of Address",
          //     RequestStatus: "Approved",
          //     ExcepetedDateOfCompletion: null,
          //   },
          //   {
          //     createdDate: "2021-08-11T13:17:53.843015",
          //     RequestId: "7279",
          //     RequestType: "Bank Modification",
          //     RequestStatus: "Approved",
          //     ExcepetedDateOfCompletion: null,
          //   },
          // ];
        }
      });
    }
  }, [props.sourceData]);

  const proceedToEsign = async (appId: any, type: any) => {
    setLoader(true);

    let result: any = await esignService.proceedToEsign(
      appId,
      types(type) as any,
      true
    );
    if (!result) openErrorPopup();
  };
  const redirectionToAddress = (sr: any) => {
    if (sr) {
      if (sr.is_digilocker_flow) {
        localStorage.setItem("digieResubmit", "Yes");
      }
      history.push("service-request/address-modification?srID=" + sr.RequestId);
    }
  };

  const openErrorPopup = () => {
    setLoader(false);
  };

  return (
    <>
      {loader && (
        <div
          style={{
            textAlign: "center",
            paddingTop: "50px",
            paddingBottom: "50px",
          }}
        >
          <Loader size={50} color="blue"></Loader>
        </div>
      )}
      {!loader && (
        <div className="table-responsive sr-page">
          <table>
            <thead>
              <th>Date and Time</th>
              <th>Request ID</th>
              <th>Request</th>
              <th>Status</th>
              <th>Expected Date of Completion</th>
              <th></th>
            </thead>
            <tbody>
              {pageData &&
                pageData.length > 0 &&
                pageData.map((data: any) => {
                  return (
                    <>
                      <tr>
                        <td className="sr_date">
                          <p>
                            {moment(data.createdDate).format(
                              "DD MMM, YYYY , hh:mm:ss A"
                            )}
                          </p>
                        </td>
                        <td>
                          <p>{data.RequestId}</p>
                          {reactList &&
                            reactList.length > 0 &&
                            data.RequestType ===
                              "Equity Dormant Reactivation" &&
                            (data.RequestStatus === "Draft Saved" ||
                              data.RequestStatus === "Approved" ||
                              data.RequestStatus === "Submitted") && (
                              <span
                                className="cursor link-text bold-text"
                                style={{ fontSize: "12px" }}
                                onClick={() => {
                                  setShow(!show);
                                }}
                              >
                                {show ? "Close" : "View Details"}
                              </span>
                            )}
                        </td>
                        <td>
                          <p>
                            {data.RequestType === "Email and Phone Update"
                              ? "Mobile & Email Modification"
                              : data.RequestType === "Bank Modification"
                              ? "Modify Bank Documents"
                              : data.RequestType ===
                                "Equity Dormant Reactivation"
                              ? "Account Reactivation"
                              : data.RequestType}
                          </p>
                        </td>
                        <td
                          className={`${
                            (Status(data)?.value === "Rejected" ||
                              Status(data)?.value === "Rejected - Resubmit") &&
                            ((data.creator_remarks &&
                              data.RequestType !== "Online Closure") ||
                              (data.approver_remarks &&
                                data.RequestType === "Online Closure"))
                              ? "positionRelative rejection-reason"
                              : ""
                          }`}
                        >
                          <label className={`sq_badge ${Status(data)?.badge}`}>
                            {Status(data)?.value}
                          </label>
                          {((data.RequestType !== "Online Closure" &&
                            data.creator_remarks) ||
                            (data.RequestType === "Online Closure" &&
                              data.approver_remarks)) && (
                            <div className="special-text-wrap positionAbsolute">
                              <p className="special-text">
                                <div className="redCircleBg">
                                  {/* <i className="edel-icon-faqs"></i> */}
                                  <i className="edel-icon-rejection-reason"></i>
                                </div>
                                <span className="special-text__tooltip">
                                  <span className="bold-text">
                                    Rejection reasons
                                  </span>
                                  <span>
                                    <br />
                                    {data.creator_remarks}
                                    {data.approver_remarks}
                                    {/* {data.RequestType === "Online Closure"
                                      ? data.creator_remarks
                                      : ""}
                                    {data.RequestType !== "Online Closure"
                                      ? data.approver_remarks
                                      : ""} */}
                                  </span>
                                </span>
                              </p>
                            </div>
                          )}
                        </td>
                        <td
                          onClick={() => {
                            if (data.RequestStatus === "PendingForEsign")
                              proceedToEsign(data.RequestId, data.RequestType);
                          }}
                        >
                          <p>
                            {" "}
                            {data.RequestStatus === "PendingForEsign" ? (
                              <span
                                onClick={() => {
                                  if (
                                    data.RequestType ===
                                    "Equity Dormant Reactivation"
                                  )
                                    proceedToEsign(
                                      data.RequestId,
                                      data.RequestType
                                    );
                                }}
                                className={
                                  data.RequestStatus === "PendingForEsign" ||
                                  data.RequestType ===
                                    "Equity Dormant Reactivation"
                                    ? "cursor link-text bold-text"
                                    : ""
                                }
                              >
                                Continue to E-sign
                              </span>
                            ) : (data.RequestType === "Change of Address" ||
                                data.RequestType === "Bank Modification" ||
                                data.RequestType === "CKYC Update") &&
                              data.RequestStatus === "Rejected - Resubmit" ? (
                              <span
                                className="cursor link-text bold-text"
                                onClick={() => {
                                  data.RequestType === "CKYC Update"
                                    ? history.push(
                                        "service-request/ckyc-update?srID=" +
                                          data.RequestId
                                      )
                                    : data.RequestType === "Bank Modification"
                                    ? history.push(
                                        "service-request/bank-modification?srID=" +
                                          data.RequestId
                                      )
                                    : redirectionToAddress(data);
                                }}
                              >
                                {"Continue To Resubmit Process"}
                              </span>
                            ) : data.RequestType ===
                                "Equity Dormant Reactivation" &&
                              (data.RequestStatus === "Draft Saved" ||
                                data.RequestStatus === "Approved" ||
                                data.RequestStatus === "InProcess" ||
                                data.RequestStatus ===
                                  "MemorandumPaymentPending") &&
                              (data.dormant_type.includes("1") ||
                                data.dormant_type.includes("6")) ? (
                              data.RequestStatus ===
                              "MemorandumPaymentPending" ? (
                                reactList &&
                                (reactList.find(
                                  (list: any) =>
                                    list.RequestType === "Memorandum Recovery"
                                ).RequestStatus ===
                                  "MemorandumPaymentPending" ||
                                  reactList.find(
                                    (list: any) =>
                                      list.RequestType === "Memorandum Recovery"
                                  ).RequestStatus === "PaymentPending") ? (
                                  <span
                                    className="cursor link-text bold-text"
                                    onClick={() => {
                                      history.push(
                                        "service-request/account-reactivation"
                                      );
                                    }}
                                  >
                                    Continue Pending Payment
                                  </span>
                                ) : (
                                  moment(data.ExcepetedDateOfCompletion).format(
                                    "DD MMM, YYYY , hh:mm:ss A"
                                  )
                                )
                              ) : (
                                <span
                                  className="cursor link-text bold-text"
                                  onClick={() => {
                                    history.push(
                                      "service-request/account-reactivation"
                                    );
                                  }}
                                >
                                  Continue Reactivation Process
                                </span>
                              )
                            ) : data.ExcepetedDateOfCompletion ? (
                              moment(data.ExcepetedDateOfCompletion).format(
                                "DD MMM, YYYY , hh:mm:ss A"
                              )
                            ) : (
                              ""
                            )}
                          </p>
                        </td>
                        <td>
                          <div className="custom-col">
                            <div className="rmDet">
                              <a
                                href={
                                  config.rootUrl +
                                  "clientarea?scroll=AdvisorDetailsSection"
                                }
                                className="link_to_rm"
                              >
                                Contact your RM
                              </a>
                            </div>
                            <label className="rm_name ng-binding">
                              {props.rmName && <>{props.rmName}</>}
                            </label>
                          </div>
                        </td>
                      </tr>
                      <>
                        {data.RequestType === "Equity Dormant Reactivation" &&
                          (data.RequestStatus === "Draft Saved" ||
                            data.RequestStatus === "Approved" ||
                            data.RequestStatus === "Submitted") &&
                          reactList &&
                          reactList.length > 0 &&
                          reactList.map((list: any) => {
                            return (
                              <tr style={{ display: show ? "revert" : "none" }}>
                                <td className="sr_date">
                                  <p>
                                    {moment(list.createdDate).format(
                                      "DD MMM, YYYY , hh:mm:ss A"
                                    )}
                                  </p>
                                </td>
                                <td>
                                  <p>{list.RequestId}</p>
                                  {list.RequestType ===
                                    "Equity Dormant Reactivation" &&
                                    list.RequestStatus === "Draft Saved" && (
                                      <span
                                        className="cursor link-text bold-text"
                                        style={{ fontSize: "12px" }}
                                      >
                                        View Details
                                      </span>
                                    )}
                                </td>
                                <td>
                                  <p>
                                    {list.RequestType ===
                                    "Email and Phone Update"
                                      ? "Mobile & Email Modification"
                                      : list.RequestType === "Bank Modification"
                                      ? "Modify Bank Documents"
                                      : list.RequestType ===
                                        "Equity Dormant Reactivation"
                                      ? "Account Reactivation"
                                      : list.RequestType}
                                  </p>
                                </td>
                                <td>
                                  <label
                                    className={`sq_badge ${
                                      Status(list)?.badge
                                    }`}
                                  >
                                    {Status(list)?.value}
                                  </label>
                                </td>
                                <td
                                  onClick={() => {
                                    if (
                                      list.RequestStatus === "PendingForEsign"
                                    )
                                      proceedToEsign(
                                        list.RequestId,
                                        list.RequestType
                                      );
                                  }}
                                >
                                  <p>
                                    {" "}
                                    {list.RequestStatus ===
                                    "PendingForEsign" ? (
                                      <span
                                        className={
                                          list.RequestStatus ===
                                          "PendingForEsign"
                                            ? "cursor link-text bold-text"
                                            : ""
                                        }
                                      >
                                        Continue to E-sign
                                      </span>
                                    ) : list.ExcepetedDateOfCompletion ? (
                                      moment(
                                        list.ExcepetedDateOfCompletion
                                      ).format("DD MMM, YYYY , hh:mm:ss A")
                                    ) : (
                                      ""
                                    )}
                                  </p>
                                </td>
                                <td>
                                  <div className="custom-col">
                                    <div className="rmDet">
                                      <a
                                        href={
                                          config.rootUrl +
                                          "clientarea?scroll=AdvisorDetailsSection"
                                        }
                                        className="link_to_rm"
                                      >
                                        Contact your RM
                                      </a>
                                    </div>
                                    <label className="rm_name ng-binding">
                                      {props.rmName && <>{props.rmName}</>}
                                    </label>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                      </>
                    </>
                  );
                })}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};

export default Table;
